<div class="container">
  <div class="row">
    <div class="col-12 mt-3">
      <page-dashboard2-coletas [isPublic]="true"></page-dashboard2-coletas>
    </div>
  </div>
</div>
